import React, {useEffect, useState} from 'react'
import {useMediaQuery} from '@mui/material'
import {useTheme} from '@mui/styles'
import {AgGridTable} from 'finsys-webcomponent'

import {columnDefs} from 'components/Metadata/Summary/Entity/ag-grid-constant'
import Layout from 'components/Metadata/Summary/Layout'
import {frameworkComponents} from 'components/InternalRequest/Summary/ag-grid-constant'
import {useEntitySummary} from 'components/Metadata/_hooks/useEntitiesSummary'
import {useEntitySummaryFilter} from 'components/Metadata/_hooks/useEntitiesSummaryFilter'
import {getPagination} from 'localstorage/PaginationSettings'

export default function Entities() {
  //table
  const theme = useTheme()
  const isIpad = useMediaQuery(theme.breakpoints.down('md'))

  // filter
  const [searchTF, setSearchTF] = useState('')
  //to cater filter
  const [filterQuery, setFilterQuery] = useState({
    searchText: '',
    temp: {
      countries: [],
      segments: [],
      currencies: [],
    },
    actual: {
      countries: [],
      segments: [],
      currencies: [],
    },
  })
  const [openFilter, setOpenFilter] = useState(false)
  const [filterCounter, setFilterCounter] = useState(null)

  //to cater AG-GRID
  const [gridApi, setGridApi] = useState(null)
  const [serverPaginationResult, setServerPaginationResult] = useState({
    rowData: [],
    totalPages: 0,
    totalCount: 0,
    page: 1,
    rowsPerPage: getPagination().rowPerPage,
    toNextPage: null,
  })

  const {entitySummary, isLoading} = useEntitySummary({
    rowsPerPage: serverPaginationResult.rowsPerPage,
    page: serverPaginationResult.page,
    searchText: filterQuery.searchText,
    filterQuery: filterQuery.actual,
  })

  const {entitySummaryFilter} = useEntitySummaryFilter()

  /**
   * To update the AG-Grid table data
   */
  useEffect(() => {
    if (entitySummary?.results) {
      setServerPaginationResult((prevState) => ({
        ...prevState,
        rowData: entitySummary.results,
        totalPages: entitySummary.total_pages,
        totalCount: entitySummary.count,
        toNextPage: entitySummary.next,
      }))
    }
  }, [entitySummary])

  /**
   * To set the actual value for filter
   */
  const handleApplyFilter = () => {
    let counter = 0
    // only if user click on apply we will set the actual value
    setFilterQuery((prevState) => {
      return {...prevState, actual: prevState.temp}
    })
    let filterObject = {}

    for (const [key, value] of Object.entries(filterQuery.temp)) {
      if (value !== null && value !== '' && value?.length !== 0) {
        counter++
      }
      filterObject[key] = value
    }

    setFilterCounter(counter !== 0 ? counter : null)
  }

  /**
   * To handle the temporary storage of data in the filter menu
   * To clear all the temporary value in the filter menu
   */
  const handleClearAllFilter = () => {
    setFilterQuery((prevState) => {
      return {
        ...prevState,
        temp: {
          countries: [],
          segments: [],
          currencies: [],
        },
      }
    })
  }

  /**
   * Default method for AG-Grid
   * @param params
   * @return {Promise<void>}
   */
  const onGridReady = async (params) => {
    setGridApi(params.api)
  }

  return (
    <Layout
      tab={'entities'}
      pageInset={205}
      retainFilter={true}
      searchPlaceholder={'Search for entity code, name'}
      searchTF={searchTF}
      setSearchTF={setSearchTF}
      setFilterQuery={setFilterQuery}
      filterQuery={filterQuery}
      filterData={entitySummaryFilter}
      handleClearAllFilter={handleClearAllFilter}
      handleApplyFilter={handleApplyFilter}
      filterCounter={filterCounter}
      openFilter={openFilter}
      setOpenFilter={setOpenFilter}
    >
      <AgGridTable
        onGridReady={onGridReady}
        gridApi={gridApi}
        serverPaginationResult={serverPaginationResult}
        setServerPaginationResult={setServerPaginationResult}
        page={serverPaginationResult.page}
        isLoading={isLoading} //@todo to be replaced
        pageInset={isIpad ? 230 : 215}
        columnDefs={columnDefs}
        frameworkComponents={frameworkComponents}
        suppressRowTransform={true}
        onColumnResized={null}
        onColumnVisible={null}
      />
    </Layout>
  )
}
